import { render, staticRenderFns } from "./TmCardInfo.vue?vue&type=template&id=6f5bb9c7&"
import script from "./TmCardInfo.vue?vue&type=script&lang=js&"
export * from "./TmCardInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports